import React, {Component} from 'react';
import Highcharts from 'highcharts';
import {inject, observer} from 'mobx-react';
import {action, observable, toJS} from "mobx";
import FormMultiSelectInput from "../../FormMultiSelectInput";
import Form, {FormBody, SelectInput, TextInput} from "../../Form";
import {station, winhydro} from '../../../actions/api';
import _ from 'lodash';

const {
    getAllRatingTableEntriesByStationIndex,
    getAllAvailableStationIndexes,
    updateRatingTable
} = winhydro;

@inject('hydrologyStore', 'stationStore')
@observer
export default class RatingTables extends Component {
    chart = null;
    originalRatings = [];

    @observable multiTypeNumberOptions = [];

    state = {
        allRatings: [],
        edit: false,
        selectedStation: '',
        selectedTypeNumbers: [],
        typeNumbersLoading: false,
        selectedTypeNumber: '',
        stations: [],
        tssStations: [],
        ratings: [],
        xmin: null,
        xmax: null,
    };

    componentDidMount() {
        getAllAvailableStationIndexes().then(res => {
            // station.fetchAll().then(res => {
            //     // console.log(res);
            //      this.setState({tssStations: res});
            // });

            if(res && !res.error)
                this.setState({stations: res});

            if (this.props.location.search) {
                try {
                    const queryParams = this.props.location.search.split('?')[1].split('&');

                    const stationIndex = queryParams.find(param => param.split('=')[0] === 'station_index');
                    const ratingTypeNo = queryParams.find(param => param.split('=')[0] === 'rating_type_no');

                    if (stationIndex && ratingTypeNo) {
                        const stationIndexValue = stationIndex.split('=')[1];

                        this.setState({selectedStation: stationIndexValue});
                        this.handleStationIndexChange({target: {value: stationIndexValue}})

                        // this.getRatingsByRatingTypeNoAndStationIndex({
                        //     rating_type_no: ratingTypeNoValue,
                        //     station_index: stationIndexValue
                        // });
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        });
    }

    // getRatingsByRatingTypeNoAndStationIndex = ({rating_type_no, station_index}) => {
    //     return getRatingTableEntriesByRatingTypeNoAndStationIndex({rating_type_no, station_index}).then(res => {
    //         this.setState({ratings: res}, () => {
    //         });
    //
    //         this.originalRatings = res;
    //
    //         return res;
    //     })
    // };

    renderChart = () => {
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }

        if (this.multiTypeNumberOptions.filter(item => item.value).length > 0) {
            this.chart = Highcharts.chart('container', {
                chart: {
                    events: {
                        redraw: (event) => {
                            if (event && event.target && event.target.axes && event.target.axes.length === 2) {
                                const [xaxis] = event.target.axes;

                                this.setState({xmax: xaxis.max, xmin: xaxis.min});

                                const sortedRatings = this.multiTypeNumberOptions.filter(item => item.value).sort((a, b) => {
                                    if (a.discharge > b.discharge) return 1; else if (a.discharge < b.discharge) return -1; else return 0;
                                });

                                const closestXAxisEntry = sortedRatings.find(rating => rating.discharge >= xaxis.min);

                                if (closestXAxisEntry) {
                                    const closestXElement = document.getElementById(`discharge-${closestXAxisEntry.discharge}`);

                                    if (closestXElement && document.getElementById('rating_table_container'))
                                        document.getElementById('rating_table_container').scrollLeft = closestXElement.offsetLeft;
                                }

                                // const rows = document.querySelectorAll('#rating_table tr td');
                                //
                                // rows[sortedRatings.indexOf(closestXAxisEntry)].scrollIntoView({
                                //     behavior: 'smooth',
                                //     block: 'center'
                                // });
                            }
                        }
                    },
                    zoomType: 'x',
                },
                title: {
                    text: 'Rating Curve'
                },
                xAxis: {
                    useHTML: true,
                    title: {
                        text: 'Discharge in m<sup>3</sup>/s'
                    }
                },
                yAxis: {
                    title: {
                        text: 'Water Level in m'
                    }
                },
                legend: {
                    enabled: true,
                    align: 'right',
                    layout: 'vertical',
                    verticalAlign: 'top',
                },
                tooltip: {
                    crosshairs: true,
                    shared: true,
                    formatter: function () {
                        let response = `<div>`;

                        if(this.points) {
                            this.points.forEach(point => {
                                if(point && point.series && point.series.name)
                                    response += '<div><span style="color: #337ab7; font-weight: bold">' + point.series.name + ' </span><span style="color: #337ab7; font-weight: bold"> (H, Q): </span><span>(' + point.y  + ', ' + this.x + ')</span><br/></div>';
                                else
                                    response += '<div><span style="color: #337ab7; font-weight: bold">Water Level in m: </span><span>' + point.y + '</span><br/></div>';

                            })
                        } else {
                            if(this && this.series && this.series.name)
                                response += '<div><span style="color: #337ab7; font-weight: bold">' + this.series.name + ' </span><br/><span style="color: #337ab7; font-weight: bold"> (H, Q): </span><span>(' + this.y + ', ' + this.x +  ')</span></div>';
                            else
                                response += '<div><span style="color: #337ab7; font-weight: bold">Water Level in m: </span><span>' + this.y + '</span></div>';
                        }

                        response += '</div>';

                        return response;
                    },
                },

                series: this.multiTypeNumberOptions.filter(item => item.value).map(ratingType => ({
                    type: 'line',
                    name: `Type No. ${ratingType.rating_type_no}, S.No. ${ratingType.serial_no} (${new Date(ratingType.start_date).toLocaleDateString()} - ${new Date(ratingType.end_date).toLocaleDateString()})`,
                    data: (ratingType.rating_table || []).sort((a,b) => +a.discharge < +b.discharge ? -1 : 1).map(rating => [rating.discharge, rating.stage]),
                    color: ratingType.color
                }))
            });
        }
    }

    @action onTypeNumberOptionClicked = item => {
        item.value = !item.value;

        this.setState({
            selectedTypeNumber: ''
        }, () => {
            this.renderChart();
        });
    }

    handleStationIndexChange = (e) => {
        this.setState({
            selectedStation: e.target.value,
            xmax: null,
            xmin: null,
            ratings: [],
            allRatings: [],
            typeNumbers: [],
            selectedTypeNumber: '',
        });

        this.originalRatings = [];

        if (e.target.value !== '') {
            getAllRatingTableEntriesByStationIndex(e.target.value).then(res => {
                this.multiTypeNumberOptions = res.map(item => ({
                    id: `Type No. ${item.rating_type_no}, S.No. ${item.serial_no} (${new Date(item.start_date).toLocaleDateString()} - ${new Date(item.end_date).toLocaleDateString()})`,
                    label: `Type No. ${item.rating_type_no}, S.No. ${item.serial_no} (${new Date(item.start_date).toLocaleDateString()} - ${new Date(item.end_date).toLocaleDateString()})`,
                    value: false,
                    ...item
                }));

                this.setState({
                    allRatings: res.filter(item => !!item.rating_table),
                    selectedTypeNumber: ''
                });
            });
        }
    };

    handleTypeNumberChange = (e) => {

        const correspondingRatingTable = this.multiTypeNumberOptions.filter(item => item.value).find(item => item.label === e.target.value);
        const correspondingRatings = correspondingRatingTable ? this.state.allRatings.find(ratings => +ratings.rating_type_no === +correspondingRatingTable.rating_type_no && +ratings.serial_no === +correspondingRatingTable.serial_no) : null;

        this.setState({
            selectedTypeNumber: e.target.value,
            xmax: null,
            xmin: null,
            ratings: correspondingRatings && correspondingRatings.rating_table ? correspondingRatings.rating_table : []
        }, () => {
            this.originalRatings = this.state.ratings;
        });
    };

    render() {
        const {stationStore} = this.props;
        const {stations, selectedStation, xmin, xmax, allRatings, selectedTypeNumber, edit, ratings, tssStations, typeNumbersLoading} = this.state;
        const associatedTSSStation = selectedStation !== '' && stationStore.items.find(station => !!(station.meta_data && station.meta_data.find(meta_data => meta_data.name === 'Station Index' && meta_data.value === selectedStation)));
        return <div style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
            <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around',
                alignItems: 'center'
            }}>
                <Form>
                    <FormBody>
                        <SelectInput label={'Station'}
                                    //  fields={{label: 'station_index', value: 'station_index'}}
                                    //  options={stations}
                                     fields={{label: 'name', value: 'id'}}
                                     options={stationStore.items}
                                     filterOptions={stationStore.filterStations}
                                     onChange={this.handleStationIndexChange}
                                     value={selectedStation}/>
                        {selectedStation !== '' && associatedTSSStation && associatedTSSStation.identifier &&
                        <TextInput readOnly={true} label={'Identifier'} value={associatedTSSStation.identifier}/>}
                        {selectedStation !== '' && associatedTSSStation && associatedTSSStation.name &&
                        <TextInput readOnly={true} label={'Name'} value={associatedTSSStation.name}/>}
                    </FormBody>
                </Form>
                <Form>
                    <FormMultiSelectInput id='type-number-multi-select'
                                          label='Type Numbers'
                                          options={this.multiTypeNumberOptions}
                                          optionClicked={this.onTypeNumberOptionClicked}
                                          isLoading={typeNumbersLoading}/>
                </Form>
            </div>
            <div style={{flex: 1}}>
                <div id='container'/>
            </div>
            {selectedStation !== '' && this.multiTypeNumberOptions.find(item => item.value) && <Form>
                <FormBody>
                    <SelectInput options={this.multiTypeNumberOptions.filter(item => item.value).map(item => ({
                        rating_type_no: `${item.rating_type_no}`,
                        label: `Type No. ${item.rating_type_no}, S.No. ${item.serial_no} (${new Date(item.start_date).toLocaleDateString()} - ${new Date(item.end_date).toLocaleDateString()})`,
                        id: `Type No. ${item.rating_type_no}, S.No. ${item.serial_no} (${new Date(item.start_date).toLocaleDateString()} - ${new Date(item.end_date).toLocaleDateString()})`,
                        key: `Type No. ${item.rating_type_no}, S.No. ${item.serial_no} (${new Date(item.start_date).toLocaleDateString()} - ${new Date(item.end_date).toLocaleDateString()})`
                    }))}
                                 label={"Type No to edit"}
                                 fields={{label: 'label', value: 'id'}}
                                 onChange={this.handleTypeNumberChange}
                                 value={selectedTypeNumber}/>
                </FormBody>
            </Form>}
            {selectedStation !== '' && selectedTypeNumber !== '' && <div style={{flex: 1, display: 'flex', width: '100%', flexDirection: 'row'}}>
                {(edit || ratings.length > 0) &&
                <div style={{overflowX: 'auto', width: edit ? '97%' : '100%'}} id={'rating_table_container'}>
                    <table style={{width: '100%', overflowX: 'auto'}}>
                        <tbody>
                        <tr>
                            <th>Stage (m)</th>
                            {ratings.map(rating => <td style={{
                                padding: 0,
                                textAlign: 'center',
                                fontWeight: rating.discharge > xmin && rating.discharge < xmax ? 'bold' : 'normal',
                                borderWidth: rating.discharge > xmin && rating.discharge < xmax ? 'thick' : 0,
                                borderColor: 'grey',
                                borderStyle: 'solid'
                            }}>{edit ? <input placeholder={rating.stage} onChange={(e) => {
                                    this.setState({
                                        ratings: ratings.map(item => {
                                            if (item.id === rating.id) {
                                                return {
                                                    id: item.id,
                                                    stage: +e.target.value,
                                                    discharge: +item.discharge
                                                };
                                            } else {
                                                return item;
                                            }
                                        })
                                    });
                                }} style={{padding: '16px 8px'}}/> :
                                <span style={{padding: '16px 8px'}}>{Number(rating.stage).toFixed(2)}</span>}</td>)}
                        </tr>
                        <tr>
                            <th>Discharge (m<sup>3</sup>/s)</th>
                            {ratings.map(rating => <td style={{
                                textAlign: 'center',
                                padding: 0,
                                fontWeight: rating.discharge > xmin && rating.discharge < xmax ? 'bold' : 'normal',
                                borderWidth: rating.discharge > xmin && rating.discharge < xmax ? 'thick' : 0,
                                borderColor: 'grey',
                                borderStyle: 'solid'
                            }} id={`discharge-${rating.discharge}`}>{edit ?
                                <input placeholder={rating.discharge} onChange={(e) => {
                                    this.setState({
                                        ratings: ratings.map(item => {
                                            if (item.id === rating.id) {
                                                return {
                                                    id: item.id,
                                                    discharge: +e.target.value,
                                                    stage: +item.stage
                                                };
                                            } else {
                                                return item;
                                            }
                                        })
                                    });
                                }} style={{padding: '16px 8px'}}/> :
                                <span style={{padding: '16px 8px'}}>{Number(rating.discharge).toFixed(2)}</span>}</td>)}
                        </tr>
                        {edit && <tr>
                            <th/>
                            {ratings.map(rating => <td style={{
                                textAlign: 'center',
                                fontWeight: rating.discharge > xmin && rating.discharge < xmax ? 'bold' : 'normal',
                            }} id={rating.discharge}>
                                <button style={{height: '100%', width: '100%', padding: '16px 0'}} onClick={() => {
                                    this.setState({
                                        ratings: ratings.filter(r => r.id !== rating.id)
                                    });
                                }}><i className={'fa fa-trash'}/></button>
                            </td>)}
                        </tr>}
                        </tbody>
                    </table>
                </div>}
                {edit && <div style={{width: '3%'}}>
                    <button style={{width: '100%', height: '100%'}} onClick={() => {
                        let newRatings = Object.assign([], ratings);
                        let newId = _.get(_.maxBy(ratings, 'id'), 'id', 0) + 1;
                        newRatings.push({
                            id: newId,
                            stage: '',
                            discharge: ''
                        });
                        this.setState({ratings: newRatings});
                        // this.setState({
                        //     ratings: [...ratings, {
                        //         id: Math.max(...ratings.map(r => r.id)) + 1,
                        //         stage: '',
                        //         discharge: ''
                        //     }]
                        // });
                    }}>
                        <i className={'fa fa-plus'}/>
                    </button>
                </div>}
            </div>}
            {selectedStation !== '' && <div style={{display: 'flex', justifyContent: 'flex-end', flex: 1}}>
                <button style={{padding: '10px'}} onClick={() => {
                    this.setState({edit: !edit});

                    if (edit) {
                        const correspondingRatingTable = this.multiTypeNumberOptions.filter(item => item.value).find(item => item.label === selectedTypeNumber);

                        if(correspondingRatingTable) {
                            updateRatingTable({
                                ratings,
                                station_index: selectedStation,
                                table_no: correspondingRatingTable.rating_type_no,
                                serial_no: correspondingRatingTable.serial_no
                            }).then(res => {
                                correspondingRatingTable.rating_table = this.state.ratings;

                                this.setState({
                                    allRatings: allRatings.map(ratings => {
                                        if (+ratings.rating_type_no === +correspondingRatingTable.rating_type_no && +ratings.serial_no === +correspondingRatingTable.serial_no) {
                                            const {rating_table, ...others} = ratings;

                                            return {
                                                ...others,
                                                rating_table: this.state.ratings
                                            };
                                        } else {
                                            return ratings;
                                        }
                                    })
                                }, () => {
                                    this.renderChart();
                                });

                                // console.log(res)
                            });
                        }
                    }
                }}>
                    {edit ? 'Save' : 'Edit'}
                </button>
                {edit && <button style={{padding: '10px'}} onClick={() => {
                    this.setState({edit: false, ratings: this.originalRatings});
                }}>
                    Discard
                </button>}
            </div>}
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/Hydrology/RT Method/RatingTables.js